import React, { useState, useEffect } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import QuestionItem from '../components/globals/QuestionItem'
import CustomPrimaryButton from '../components/globals/CustomPrimaryButton'
import ProgressBar from 'react-bootstrap/ProgressBar'
import { MdOutlineKeyboardArrowLeft } from 'react-icons/md'
import { useLocation, useNavigate } from 'react-router-dom'
import CustomStageBox from '../components/globals/CustomStageBox'
import { FaBookReader } from 'react-icons/fa'
import jumpingshark from '../assets/images/jumping-shark.gif'
import { GiSkills } from 'react-icons/gi'
import { oceanAtom } from "../store/oceanAtom"
import { apiPost } from '../utils/Api';
import { ENDPOINTS } from '../utils/EndPoint';
import { useRecoilState } from 'recoil'
import { isLoaderState, snakeBarState } from "../store/RecoilStore"
import { useParams } from 'react-router-dom';
import bulb from '../assets/images/coinsaccuracy.png'
import AccuracyItem from '../components/globals/AccuracyItem'
import LessonAudio from '../components/globals/LessonAudio'
import getGif from '../utils/Helper';
import CustomModal from '../components/globals/CustomModal';

function Stages() {

    let { stageId } = useParams();

    const [stepForm, setStepForm] = useState(0);

    const [isBackWarningModalVisible, setIsBackWarningModalVisible] = useState(false);

    const [ocean, setOcean] = useRecoilState(oceanAtom);
    const [isLoaderInfo, setIsLoaderInfo] = useRecoilState(isLoaderState);
    const [snackBarInfo, setSnackBarInfo] = useRecoilState(snakeBarState);

    const [showAnimation, setShowAnimation] = useState(false);
    const [animationSrc, setAnimationSrc] = useState('');
    const [showButton, setShowButton] = useState(false);

    const [accuracy, setAccuracy] = useState(0);
    const [coins, setCoins] = useState(0);
    const [rewards, setRewards] = useState(0);

    const [lessons, setLessons] = useState([])
    const [lessonIndex, setLessonIndex] = useState(0)
    const [questionIndex, setQuestionIndex] = useState(0)
    const [selectedAnswer, setSelectedAnswer] = useState(null)
    const [selectedMiniQuizAnswer, setSelectedMiniQuizAnswer] = useState(null)
    const [selectedMiniQuiz, setselectedMiniQuiz] = useState(null)
    const [isQuizLoaded, setIsQuizLoaded] = useState(false);
    const [isQuestionAnswered, setIsQuestionAnswered] = useState(false);
    const [showAnswerIndicators, setShowAnswerIndicators] = useState(false);
    const [isAnswersShown, setIsAnswersShown] = useState(false);
    const [animationText, setAnimationText] = useState("");

    const location = useLocation();
    const { selectedStage } = location.state || {};

    useEffect(() => {
        getLessons();
        miniQuiz();
    }, []);

    const handleContinue = () => {
        setShowAnimation(false);
    };

    useEffect(() => {
        if (stepForm === 4 && questionIndex === selectedMiniQuiz?.questions?.length) {
            completeQuiz();
        }
    }, [questionIndex, stepForm, selectedMiniQuiz]);

    const getLessons = async () => {
        setIsLoaderInfo(true)
        let payload = {
            stage_id: stageId,
            ocean_id: ocean?.id
        }
        apiPost(
            ENDPOINTS.GetLessons,
            payload,
            (res) => {
                let filterData = res.data.filter((item) => !item.is_lesson_complete);
                setLessons(filterData);

                if (filterData.length === 0) {
                    setStepForm(3);
                }
                setLessons(filterData)
                setIsLoaderInfo(false)
            },
            (err) => {
                console.log("err", err)
                setIsLoaderInfo(false)
            });
    }

    const lessonsComplete = async () => {

        let payload = {
            ocean_id: selectedAnswer.ocean_id,
            lesson_id: selectedAnswer.lesson_id,
            stage_id: selectedAnswer.stage_id
        }
        apiPost(
            ENDPOINTS.CompleteLesson,
            payload,
            (res) => {
            },
            (err) => {
                console.log("err", err)
            });
    }

    const completeQuiz = async () => {
        let payload = {
            ocean_id: ocean?.id,
            mini_quiz_id: selectedMiniQuiz?.id,
            stage_id: stageId
        };
        apiPost(
            ENDPOINTS.CompleteMiniQuiz,
            payload,
            (res) => {
                if (res?.data) {
                    let accuracyValue = parseFloat(res.data.accuracy);
                    setAccuracy(accuracyValue.toFixed(2));

                    let coinsValue = parseFloat(res.data.spend_coins);
                    setCoins(coinsValue.toFixed(2));

                    let rewardsValue = parseFloat(res.data.reward_price);
                    setRewards(rewardsValue.toFixed(2));
                } else {
                    setAccuracy(0);
                    setCoins(0);
                }
                setStepForm(5);
            },
            (err) => {
                console.log("Error:", err);
                setAccuracy(0);
                setCoins(0);
            }
        );
    };

    const miniQuiz = async () => {

        if (isQuizLoaded) return;

        let payload = {
            ocean_id: ocean?.id,
            stage_id: stageId
        }
        apiPost(
            ENDPOINTS.MiniQuiz,
            payload,
            (res) => {
                setselectedMiniQuiz(res?.data)
                setIsQuizLoaded(true);
            },
            (err) => {
                console.log("Error:", err);
                setAccuracy(0);
                setCoins(0);
            }
        );
    }

    const handlePrevious = () => {
        if (stepForm > 0) {
            setStepForm(stepForm - 1);
        }
    };

    const navigate = useNavigate();

    const createMarkup = (html) => {
        return { __html: html };
    };

    const handleAnswer = (item) => {
        setSelectedAnswer(item)
    }

    const handleMiniQuizAnswer = (item) => {
        setSelectedMiniQuizAnswer(item);
    };

    const handleBackToLesson = () => {
        // Reset the question index to 0 and set the stepForm to 1 (Lesson view)
        setQuestionIndex(0);  // Go back to the first question (or adjust if needed)
        setStepForm(1);  // Set stepForm to 1 to show the lesson screen

        // Reset any other states you want (like selected answer or indicators)
        setIsQuestionAnswered(false);
        setIsAnswersShown(false);
        setShowAnswerIndicators(false);
    };

    const handleQuestion = () => {
        if (selectedAnswer) {
            const body = {
                question_id: selectedAnswer?.question_id,
                answer_id: selectedAnswer?.answer_id,
                ocean_id: selectedAnswer?.ocean_id,
                lesson_id: selectedAnswer?.lesson_id,
                stage_id: selectedAnswer?.stage_id,
            };

            setIsLoaderInfo(true);
            apiPost(
                ENDPOINTS.AddQuestionAnswers,
                body,
                (res) => {
                    const isCorrect = res?.data?.is_correct;

                    // Show GIF animation for 3 seconds
                    const gif = getGif({
                        fromStage: true,
                        fromQuest: false,
                        fromChallenge: false,
                        stageId: selectedStage?.stage_number,
                        level: selectedAnswer?.level,
                        isCorrect,
                    });

                    setAnimationSrc(gif);
                    setShowAnimation(true);

                    setAnimationText(isCorrect ? "Great job! That's the correct answer!" : "Oops, that's not the correct answer.");

                    setTimeout(() => {
                        setShowAnimation(false);
                        setShowAnswerIndicators(true); // Show correct/incorrect answers
                        setIsQuestionAnswered(true);  // Disable all answer options
                        setIsAnswersShown(true);      // Mark answers as shown
                    }, 3000);

                    setIsLoaderInfo(false);
                },
                (err) => {
                    console.log("Error:", err);
                    setIsLoaderInfo(false);
                }
            );
        } else {
            setSnackBarInfo({
                snackStatus: true,
                snackColor: "bg-danger",
                snackMsg: "Please select an answer",
            });
        }
    };

    const handleContinueQuestion = () => {
        if (isAnswersShown) {
            const isLastQuestion = lessons[lessonIndex]?.questions[lessons[lessonIndex]?.questions?.length - 1]?.id === selectedAnswer?.question_id;
            const isLastLesson = lessons[lessons?.length - 1]?.id === selectedAnswer?.lesson_id;

            if (isLastQuestion) {
                if (isLastLesson) {
                    lessonsComplete();
                    miniQuiz();
                    setStepForm(3);
                } else {
                    // Move to the next lesson
                    setStepForm(1);
                    setQuestionIndex(0);
                    setLessonIndex(lessonIndex + 1);
                    lessonsComplete();
                }
            } else {
                // Move to the next question within the same lesson
                setQuestionIndex(questionIndex + 1);
            }

            // Reset states for the next question
            setIsAnswersShown(false);
            setIsQuestionAnswered(false);
            setSelectedAnswer(null);
            setShowAnswerIndicators(false);
        }
    };

    const handleMiniQuizQuestion = (item) => {
        if (item) {
            const body = {
                question_id: item?.question_id,
                answer_id: item?.answer_id,
                mini_quiz_id: selectedMiniQuiz?.id,
                stage_id: stageId,
                ocean_id: ocean?.id,
            };

            setIsLoaderInfo(true);

            apiPost(
                ENDPOINTS.AddMiniQuizQuestionAnswers,
                body,
                (res) => {
                    const isCorrect = res?.data?.is_correct;

                    // Show GIF animation for 3 seconds
                    const gif = getGif({
                        fromStage: true,
                        fromQuest: false,
                        fromChallenge: false,
                        stageId: selectedStage?.stage_number,
                        level: item?.level,
                        isCorrect,
                    });

                    setAnimationSrc(gif);
                    setShowAnimation(true);

                    setAnimationText(isCorrect ? "Great job! That's the correct answer!" : "Oops, that's not the correct answer.");

                    // Highlight correct/incorrect answers after animation
                    setTimeout(() => {
                        setShowAnimation(false);
                        setShowAnswerIndicators(true); // Show correct/incorrect answers
                        setIsQuestionAnswered(true);  // Disable all answer options
                        setIsAnswersShown(true);      // Mark answers as shown
                    }, 3000);

                    setIsLoaderInfo(false);
                },
                (err) => {
                    console.log("Error:", err);
                    setIsLoaderInfo(false);
                }
            );
        } else {
            setSnackBarInfo({
                snackStatus: true,
                snackColor: "bg-danger",
                snackMsg: "Please select an answer",
            });
        }
    };

    const handleMiniQuizContinue = () => {
        if (isAnswersShown) {
            const isLastQuestion = selectedMiniQuiz?.questions[selectedMiniQuiz?.questions?.length - 1]?.id === selectedMiniQuizAnswer?.question_id;

            if (isLastQuestion) {
                completeQuiz();
            } else {
                // Move to the next question
                setQuestionIndex(questionIndex + 1);
            }

            // Reset states for the next question
            setIsAnswersShown(false);
            setIsQuestionAnswered(false);
            setSelectedMiniQuizAnswer(null);
            setShowAnswerIndicators(false);
        }
    };


    useEffect(() => {
        console.log("Lessons at render:", lessons);
    }, [lessons]);

    return (
        <>
            <Container fluid className='p-0 custom-welcome d-flex flex-column align-items-center justify-content-center'>

                {stepForm == 0 && (
                    <div className='mb-4 stage-btn-first'>
                        <CustomPrimaryButton
                            btnTextPro={<MdOutlineKeyboardArrowLeft size={40} />}
                            classNamePro="custom-progress-btn"
                            handleOnClick={() => {
                                navigate('/admin/ocean');
                            }}
                        />
                    </div>
                )}

                <Row className='g-0 justify-content-center'>

                    <Col md={12} lg={12} className='align-items-center'>

                        {(stepForm === 2 || stepForm === 4) && (
                            <div
                                className={`progress-bar-cls w-100 d-flex align-items-center gap-5 mb-4 mt-3 ${stepForm > 0 ? "justify-content-start" : "justify-content-center"}`}
                            >
                                <CustomPrimaryButton
                                    btnTextPro={<MdOutlineKeyboardArrowLeft size={40} />}
                                    classNamePro="custom-progress-btn"
                                    handleOnClick={() => setIsBackWarningModalVisible(true)}
                                />
                                <ProgressBar
                                    now={
                                        stepForm === 2
                                            ? (questionIndex * 100) / lessons[lessonIndex]?.total_questions
                                            : (questionIndex * 100) / selectedMiniQuiz?.questions?.length
                                    }
                                    className="w-100"
                                    variant="warning"
                                />
                            </div>
                        )}

                        {stepForm == 0 && (
                            <CustomStageBox />
                        )}

                        {lessons && lessons.length > 0 &&
                            <>

                                {stepForm === 1 && (
                                    <div className='container'>
                                        <div className='row text-white'>
                                            <h5 className='skranji-regular mb-3'>Lesson</h5>
                                            <h1 className='mb-3 mt-3'>{lessons[lessonIndex]?.name}</h1>
                                            <div className='d-flex align-items-center mt-3 mb-3'>
                                                <div className='d-flex align-items-center me-4'>
                                                    <GiSkills />
                                                    <p className='mb-0 ms-1'><strong>{lessons[lessonIndex]?.ocean?.name}</strong></p>
                                                </div>

                                                <div className='d-flex align-items-center me-4'>
                                                    <FaBookReader />
                                                    <p className='mb-0 ms-1'><strong>{lessons[lessonIndex]?.total_questions} Question</strong></p>
                                                </div>
                                            </div>
                                            <div className='pt-4 pb-4 d-flex justify-content-between align-items-center custom-stage-border'>
                                                <CustomPrimaryButton
                                                    btnTextPro="Next"
                                                    handleOnClick={() => setStepForm(stepForm + 1)}
                                                />


                                                <LessonAudio
                                                    audioSrc={
                                                        lessons[lessonIndex]?.lesson_audio
                                                            ? `${process.env.REACT_APP_BASE_URL}/storage/${lessons[lessonIndex].lesson_audio}`
                                                            : null
                                                    }
                                                    shouldPause={showAnimation}
                                                />
                                            </div>

                                            <div className='description-content'>
                                                <p className='font-22 mt-4' dangerouslySetInnerHTML={createMarkup(lessons[lessonIndex]?.description)} />
                                            </div>

                                            <img src={jumpingshark} className='jumpingshark' />
                                        </div>
                                    </div>

                                )}

                                {stepForm === 2 &&
                                    lessons[lessonIndex]?.questions?.length > 0 &&
                                    lessons[lessonIndex]?.questions?.map((item, ind) => (
                                        questionIndex == ind && (
                                            <Row key={ind}>
                                                <Row className='d-flex align-items-center mb-3'>
                                                    <Col md={9} lg={9}>
                                                        <h3 className='skranji-bold text-white'>{item.question}</h3>
                                                    </Col>
                                                    <Col md={3} lg={3} className='p-0'>
                                                        <CustomPrimaryButton
                                                            btnTextPro={
                                                                <>
                                                                    <MdOutlineKeyboardArrowLeft size={30} />
                                                                    <p>Back To Lesson</p>
                                                                </>
                                                            }
                                                            classNamePro="custom-progress-btn back-to-lesson"
                                                            handleOnClick={handleBackToLesson}
                                                        />
                                                    </Col>
                                                </Row>

                                                <Col md={12} lg={12}>
                                                    {item?.answers.map((answer, ind2) => (
                                                        <QuestionItem key={ind2} text={answer?.answer} onClick={() => handleAnswer({
                                                            question_id: answer?.question_id,
                                                            answer_id: answer?.id,
                                                            ocean_id: answer?.ocean_id,
                                                            lesson_id: answer?.lesson_id,
                                                            stage_id: answer?.stage_id,
                                                        })} isSelected={selectedAnswer && selectedAnswer?.answer_id == answer?.id}
                                                            isCorrect={showAnswerIndicators ? answer?.is_correct : undefined}
                                                            isDisabled={isQuestionAnswered}
                                                        />
                                                    ))}

                                                </Col>
                                            </Row>
                                        )
                                    ))
                                }

                            </>
                        }

                        {selectedMiniQuiz && (
                            <>
                                {/* Mini Quiz Section */}
                                {stepForm === 3 && (
                                    <div className='container'>
                                        <div className='row text-white'>
                                            <h5 className='skranji-regular mb-3'>Mini Quiz</h5>
                                            <h1 className='mb-3 mt-3'>{selectedMiniQuiz?.name}</h1>
                                            <div className='d-flex align-items-center mt-3 mb-3'>
                                                <div className='d-flex align-items-center me-4'>
                                                    <GiSkills />
                                                    <p className='mb-0 ms-1'><strong>{selectedMiniQuiz?.ocean?.name}</strong></p>
                                                </div>
                                                <div className='d-flex align-items-center me-4'>
                                                    <FaBookReader />
                                                    <p className='mb-0 ms-1'><strong>3 Question</strong></p>
                                                    {/* <p className='mb-0 ms-1'><strong>{selectedMiniQuiz?.total_questions} Question</strong></p> */}
                                                </div>
                                            </div>
                                            <div className='pt-4 pb-4 d-flex justify-content-between align-items-center custom-stage-border'>
                                                <CustomPrimaryButton
                                                    btnTextPro="Next"
                                                    handleOnClick={() => setStepForm(stepForm + 1)}
                                                />
                                                {/* <CustomPrimaryButton
                                                    btnTextPro={<FaVolumeHigh size={30} />}
                                                /> */}
                                            </div>
                                            <div className='description-content'>
                                                <p className='font-22 mt-4' dangerouslySetInnerHTML={createMarkup(selectedMiniQuiz?.description)} />
                                            </div>
                                            <img src={jumpingshark} className='jumpingshark' />
                                        </div>
                                    </div>
                                )}

                                {/* Question Display */}
                                {stepForm === 4 && selectedMiniQuiz?.questions?.map((item, ind) => (
                                    questionIndex === ind && (
                                        <Row key={ind}>
                                            <Col md={12} lg={12}>
                                                <h3 className="skranji-bold text-white">{item.question}</h3>
                                            </Col>
                                            <Col md={12} lg={12}>
                                                {item?.answers.map((answer, ind2) => (
                                                    <QuestionItem
                                                        key={ind2}
                                                        text={answer?.answer}
                                                        onClick={() => handleMiniQuizAnswer({
                                                            question_id: answer?.question_id,
                                                            answer_id: answer?.id,
                                                            ocean_id: answer?.ocean_id,
                                                            mini_quiz_id: answer?.mini_quiz_id,
                                                            stage_id: answer?.stage_id,
                                                        })}
                                                        isSelected={selectedMiniQuizAnswer && selectedMiniQuizAnswer?.answer_id === answer?.id}
                                                        isCorrect={showAnswerIndicators ? answer?.is_correct : undefined} // Highlight correct/incorrect
                                                        isDisabled={isQuestionAnswered} // Disable after submission
                                                    />
                                                ))}
                                            </Col>
                                        </Row>
                                    )
                                ))}

                                {/* Quiz Completion Message */}
                                {stepForm === 5 && (
                                    <div className='container text-center'>
                                        <p className='font-22 mt-4 text-white'>You have completed the mini quiz.</p>
                                        <p className='font-22 mt-4 text-white'>If you answered 2 or 3 questions correct you can proceed to the next stage</p>
                                        <AccuracyItem
                                            welcomeicon={bulb} customText="Accuracy" text={` ${accuracy ? accuracy : 0}%`}
                                        />
                                        <AccuracyItem
                                            welcomeicon={bulb} customText="Coins" text={` ${coins ? coins : 0}`}
                                        />

                                        <AccuracyItem
                                            welcomeicon={bulb} customText="Rewards" text={` ${rewards ? rewards : 0}`}
                                        />
                                    </div>
                                )}
                            </>
                        )}


                    </Col>
                </Row>

            </Container>

            <div className='welcome-bottom-box container-fluid'>
                {stepForm < 1 && (
                    <CustomPrimaryButton
                        btnTextPro="Continue"
                        handleOnClick={() => setStepForm(stepForm + 1)}
                        classNamePro="btn-custom-welcome"
                        customWelcomeClass="custom-welcome-class"
                    />
                )}

                {stepForm === 2 && (
                    <CustomPrimaryButton
                        btnTextPro={isAnswersShown ? "Continue" : "Submit"}
                        handleOnClick={isAnswersShown ? handleContinueQuestion : handleQuestion}
                        classNamePro="btn-custom-welcome"
                        customWelcomeClass="custom-welcome-class"
                    />
                )}

                {stepForm === 4 && (
                    <CustomPrimaryButton
                        btnTextPro={isAnswersShown ? "Continue" : "Submit"}
                        handleOnClick={isAnswersShown ? handleMiniQuizContinue : () => {
                            if (selectedMiniQuizAnswer) {
                                handleMiniQuizQuestion(selectedMiniQuizAnswer);
                            } else {
                                setSnackBarInfo({
                                    snackStatus: true,
                                    snackColor: "bg-danger",
                                    snackMsg: "Please select an answer",
                                });
                            }
                        }}
                        classNamePro="btn-custom-welcome"
                        customWelcomeClass="custom-welcome-class"
                    />
                )}


                {stepForm === 5 && (
                    <CustomPrimaryButton
                        btnTextPro="Continue"
                        handleOnClick={() => navigate('/admin/ocean')}
                        classNamePro="btn-custom-welcome"
                        customWelcomeClass="custom-welcome-class"
                    />
                )}

                {showAnimation && (
                    <div className="popup-overlay">
                        <div className="popup-container">
                            <p className="animation-text">{animationText}</p>
                            <img src={animationSrc} alt="Result Animation" className="animation-gif" />
                            {showButton && (
                                <CustomPrimaryButton
                                    btnTextPro="Continue"
                                    classNamePro="custom-progress-btn-animation"
                                    handleOnClick={handleContinue}
                                />
                            )}
                        </div>
                    </div>
                )}


            </div>

            <CustomModal
                size="md"
                hideModal={() => setIsBackWarningModalVisible(false)}
                showModal={isBackWarningModalVisible}
                title="Warning"
                onClose={() => setIsBackWarningModalVisible(false)}
            >
                <div className="container text-center">
                    <h5 className="text-white mb-4">Your coins will be lost if you go back without answering the question!</h5>
                    <p className="text-white">Do you still want to go back?</p>
                    <div className="d-flex justify-content-center mt-4">
                        <CustomPrimaryButton
                            btnTextPro="Go Back"
                            classNamePro="btn btn-danger mt-2"
                            handleOnClick={() => {
                                setIsBackWarningModalVisible(false);
                                navigate('/admin/ocean');
                            }}
                        />
                        <CustomPrimaryButton
                            btnTextPro="Cancel"
                            classNamePro="btn btn-secondary mt-2 mx-2 text-black"
                            handleOnClick={() => setIsBackWarningModalVisible(false)}
                        />
                    </div>
                </div>
            </CustomModal>
        </>
    )
}

export default Stages;